// models

import { PetBreed, PetWeight } from '@app/services/graphql.service';
import { ParsedBooking } from '@app/models/booking.model';
import { ParsedPetVaccine } from '@app/models/pet/pet-vaccine.model';

export interface PetStatus {
  id: string;
  firstName: string;
  lastName: string;
  nickName: string;
  weight: Partial<PetWeight>;
  breeds: Partial<PetBreed>[];
  upcomingReservations: Partial<ParsedBooking>[];
  vaccines: Partial<ParsedPetVaccine>[];
  interviewRequests: Partial<ParsedBooking>[];
  statusId: number;
  numberOfUnverifiedPetVaccinations: number;
}

export enum PetStatusType {
  PASSED_INTERVIEW = 5,
  INACTIVE = 6,
  FAILED = 7,
  DISMISSED = 8,
  DECEASED = 9,
  PENDING_INTERVIEW = 31,
}
